import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import {
  Drawer,
  Select,
  Spin,
  Button,
  Table as AntTable,
  Input,
  Modal,
} from "antd";
import {
  getApiBaseUrl,
  GETMASTERSREASONS,
  UPDATEFILTERSTATUS,
  ADD_ACTIVITY,
  LOGIN,
} from "../../../Config/Config";

const { Option } = Select;
const { TextArea } = Input;

const BulkUpdateOffcanvas = ({
  selectedIds,
  setSelectedIds,
  fetchFilters,
  setFiltersData,
  setLoadingFilters,
  selectedBlock,
  setIsManualOverride,
  visible,
  onClose,
}) => {
  const [bulkStatus, setBulkStatus] = useState("");
  const [bulkFormData, setBulkFormData] = useState([]);
  const [washingEquipments, setWashingEquipments] = useState([]);
  const [dryerEquipmentOptions, setDryerEquipmentOptions] = useState([]);
  const [washingReasons, setWashingReasons] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isReauthModalVisible, setIsReauthModalVisible] = useState(false);
  const [reauthPassword, setReauthPassword] = useState("");
  const [reauthLoading, setReauthLoading] = useState(false);
  const [isReauthenticated, setIsReauthenticated] = useState(false);
  const [deviationMessage, setDeviationMessage] = useState("");
  const [adhocRemarks, setAdhocRemarks] = useState("");
  const [pressureGroups, setPressureGroups] = useState([]);
  const [selectedPressureGroupId, setSelectedPressureGroupId] = useState(null);
  const [groupLoading, setGroupLoading] = useState(false);
  const [groupDataLoading, setGroupDataLoading] = useState(false);
  useEffect(() => {
    if (!visible) {
      setAdhocRemarks("");
    }
  }, [visible]);
  const [commonFields, setCommonFields] = useState({
    washingEquipId: null,
    washingReasonId: null,
    RoWaterPressure: "",
    DryerEquipId: null,
    Duration: null,
    AirPressure: "",
    DryerTemp: "",
  });

  const processOrderMapping = {
    "Wash In": 1,
    "Wash Out": 2,
    "Dry In": 3,
    "Dry Out": 4,
    "Storage-In": 5,
    "Storage-Out": 6,
  };

  const stageNameMapping = {
    0: "To Be Cleaned",
    1: "Wash In",
    2: "Wash Out",
    3: "Dry In",
    4: "Dry Out",
    5: "Storage-In",
    6: "Storage-Out",
  };

  const auditLogDescription = {
    "Wash In": "(Web) Washing In Process",
    "Wash Out": "(Web) Washing Out Process",
    "Dry In": "(Web) Drying In Process",
    "Dry Out": "(Web) Drying Out Process",
    "Storage-In": "(Web) Storage In Process",
    "Storage-Out": "(Web) Storage Out Process",
  };

  const [newEquipmentsData, setNewEquipmentsData] = useState([]);
  const [newAirPressure, setNewAirPressure] = useState(null);
  const [newWaterPressure, setNewWaterPressure] = useState(null);
  const [newTemperature, setNewTemperature] = useState(null);

  const fetchData = async () => {
    if (!selectedBlock) return;
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/api/getPressureByBlock?blockId=${selectedBlock}`,
      );
      const data = await res.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const equipments = data.ResultData.filter(
          (item) => item.Type === 0,
        ).map((item) => ({
          Id: item.EquipmentId,
          EquipmentName: item.Name,
          SerialNumber: item.EquipmentId,
          BlockId: item.BlockId,
        }));

        const air = data.ResultData.find((item) => item.Type === 1);
        const water = data.ResultData.find((item) => item.Type === 2);
        const temp = data.ResultData.find((item) => item.Type === 3);

        setNewEquipmentsData(equipments);
        setWashingEquipments(equipments);
        setDryerEquipmentOptions(equipments);

        if (air) {
          setNewAirPressure({
            min: air.Min,
            max: air.max,
            unit: air.Unit,
            name: air.Name,
            step: air.LeastCount,
            opMin: air.OperatingMin,
            opMax: air.OperatingMax,
          });
        }

        if (water) {
          setNewWaterPressure({
            min: water.Min,
            max: water.max,
            unit: water.Unit,
            name: water.Name,
            step: water.LeastCount,
            opMin: water.OperatingMin,
            opMax: water.OperatingMax,
          });
        }

        if (temp) {
          setNewTemperature({
            min: temp.Min ?? 0,
            max: temp.max ?? 0,
            unit: temp.Unit || "°C",
            name: temp.Name || "Temperature",
            step: temp.LeastCount ?? 0.1,
            opMin: temp.OperatingMin ?? temp.Min ?? 0,
            opMax: temp.OperatingMax ?? temp.max ?? 0,
          });
        }
      } else {
        console.warn("Invalid data from getPressureByBlock:", data);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  const fetchPressureGroups = async () => {
    if (!selectedBlock) return;
    setGroupLoading(true);
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/Blocks/getPressureGroups?BlockId=${selectedBlock}`,
      );
      if (!res.ok) throw new Error("Failed to fetch pressure groups");
      const data = await res.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const active = data.ResultData.filter((g) => g.IsActive !== false);
        setPressureGroups(active);
        if (active.length === 1) {
          setSelectedPressureGroupId(active[0].Id);
        }
      } else {
        setPressureGroups([]);
      }
    } catch (err) {
      console.error("Error fetching pressure groups:", err);
      setPressureGroups([]);
    } finally {
      setGroupLoading(false);
    }
  };

  const fetchGroupPressureData = async (groupId) => {
    if (!selectedBlock || !groupId) return;
    setGroupDataLoading(true);

    try {
      const res = await fetch(
        `${getApiBaseUrl()}/Blocks/getPressuredataByGroup?BlockId=${selectedBlock}&PressureGroupId=${groupId}`,
      );
      if (!res.ok) throw new Error("Failed to fetch group pressure data");
      const data = await res.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const items = data.ResultData;

        const airItem = items.find((i) => i.Type === 1);
        const waterItem = items.find((i) => i.Type === 2);
        const tempItem = items.find((i) => i.Type === 3);

        if (airItem) {
          setNewAirPressure({
            min: Number(airItem.Min ?? 0),
            max: Number(airItem.max ?? 0),
            unit: airItem.Unit || "bar",
            step: Number(airItem.LeastCount ?? 0.1),
            opMin: Number(airItem.OperatingMin ?? airItem.Min ?? 0),
            opMax: Number(airItem.OperatingMax ?? airItem.max ?? 0),
            name: airItem.Name,
          });
        }

        if (waterItem) {
          setNewWaterPressure({
            min: Number(waterItem.Min ?? 0),
            max: Number(waterItem.max ?? 0),
            unit: waterItem.Unit || "bar",
            step: Number(waterItem.LeastCount ?? 0.1),
            opMin: Number(waterItem.OperatingMin ?? waterItem.Min ?? 0),
            opMax: Number(waterItem.OperatingMax ?? waterItem.max ?? 0),
            name: waterItem.Name,
          });
        }

        if (tempItem) {
          setNewTemperature({
            min: Number(tempItem.Min ?? 0),
            max: Number(tempItem.max ?? 0),
            unit: tempItem.Unit || "°C",
            step: Number(tempItem.LeastCount ?? 0.1),
            opMin: Number(tempItem.OperatingMin ?? tempItem.Min ?? 0),
            opMax: Number(tempItem.OperatingMax ?? tempItem.max ?? 0),
            name: tempItem.Name,
          });
        }
      }
    } catch (err) {
      console.error("Error fetching group pressure data:", err);
    } finally {
      setGroupDataLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    console.log(newEquipmentsData);
  }, [selectedBlock]);

  useEffect(() => {
    if (visible && selectedBlock) {
      fetchPressureGroups();
    }
  }, [visible, selectedBlock]);

  useEffect(() => {
    if (selectedPressureGroupId) {
      fetchGroupPressureData(selectedPressureGroupId);
    }
  }, [selectedPressureGroupId]);

  useEffect(() => {
    if (bulkStatus !== "Wash In" && bulkStatus !== "Dry In") {
      setSelectedPressureGroupId(null);
    }
  }, [bulkStatus]);

  const generatePressureOptions = (range) => {
    if (
      !range ||
      typeof range.min !== "number" ||
      typeof range.max !== "number" ||
      typeof range.step !== "number" ||
      range.step <= 0 ||
      isNaN(range.min) ||
      isNaN(range.max) ||
      isNaN(range.step) ||
      range.min > range.max
    ) {
      console.warn("Invalid range for pressure options:", range);
      return [];
      
    }

    const options = [];
    const unit = range.unit || "bar";

    let v = range.min;
    while (v <= range.max + 0.0001) {
      const value = Number(v?.toFixed(2));
      if (isNaN(value)) break; // Safety
      options.push({
        value: value.toString(),
        label: `${value} ${unit}`,
      });
      v += range.step;
    }

    return options;
  };
  const pressureOptions = generatePressureOptions(newWaterPressure);

  const airPressureSelectOptions = generatePressureOptions(newAirPressure);
  const tempSelectOptions = generatePressureOptions(newTemperature);

  useEffect(() => {
    if (bulkStatus === "Wash In") {
      fetch(`${getApiBaseUrl()}${GETMASTERSREASONS}?Type=2`)
        .then((res) => res.json())
        .then((data) => {
          if (data?.Status && Array.isArray(data.ResultData)) {
            setWashingReasons(data.ResultData);
          } else {
            console.warn("Invalid washing reasons data:", data);
          }
        })
        .catch((err) => {
          console.error("Failed to load washing reasons:", err);
        });
    }
  }, [bulkStatus]);

  useEffect(() => {
    if (visible && selectedIds.length > 0) {
      setBulkFormData(
        selectedIds.map((item) => ({
          ID: item.Id,
          FilterId: item.Lable || "",
          Barcode: item.Rfid || "",
          Remarks: item.Remarks || "",  
          Status: item.Status,
          LastCleaningDate: item.LastCleaningDate,
          cleaningdays: item.cleaningdays,
          AHUId: item?.AHUId,
        })),
      );
      setCommonFields({
        washingEquipId: null,
        washingReasonId: null,
        RoWaterPressure: "",
        DryerTemp: "",
        Duration: null,
        AirPressure: "",
      });
      setIsReauthenticated(false);
      setDeviationMessage("");
    }
  }, [visible, selectedIds]);

  const checkStageSequence = async (rfid, orderNum, performedBy) => {
    if (!rfid) {
      return
    }
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/CheckOrderedStageRfId`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // BarcodeNum: barcode,
           RfIdNum: rfid,
          OrderNum: orderNum,
          PerformedBy: performedBy,
        }),
      });
      const result = await response.json();

      const isValid = result?.ResultData?.[0]?.Status === "true";
      const currentStage =
        stageNameMapping[bulkFormData?.[0]?.Status] || "Unknown";
      const newStage = stageNameMapping[orderNum] || "Unknown";
      const message = isValid
        ? ""
        : `Attempted transition from ${currentStage} to ${newStage} for Filters: ${result?.ResultData?.[0]?.Lable}`;

      return { isValid, message };
    } catch (error) {
      console.error("Error checking stage sequence:", error);
      return {
        isValid: false,
        message: `Failed to validate stage sequence for Filter: ${rfid}`,
      };
    }
  };

  const checkDryerDuration = (filter) => {
    if (
      bulkStatus !== "Dry Out" ||
      !filter.LastCleaningDate ||
      !filter.cleaningdays
    ) {
      return { isValid: true, message: "" };
    }

    const lastCleaning = new Date(filter.LastCleaningDate);
    const currentTime = new Date();
    const durationDays = (currentTime - lastCleaning) / (1000 * 60 * 60 * 24);
    const minDuration = filter.cleaningdays;

    if (durationDays < minDuration) {
      return {
        isValid: false,
        message: `Dryer duration is ${durationDays?.toFixed(
          1,
        )} , less than the required ${minDuration}  for Filter: ${
          filter?.Lable
        }`,
      };
    }
    return { isValid: true, message: "" };
  };

  const checkPressureValues = () => {
    const messages = [];

    // Get list of all filter IDs (since values are common)
    const allFilterIds = bulkFormData.map((f) => f.FilterId).join(", ");

    if (bulkStatus === "Wash In") {
      // RO Water Pressure
      if (
        commonFields.RoWaterPressure &&
        commonFields.RoWaterPressure !== "N/A"
      ) {
        const roPressure = parseFloat(commonFields.RoWaterPressure);
        if (isNaN(roPressure)) {
          messages.push(
            `Invalid RO Water Pressure value for Filters: ${allFilterIds}`,
          );
        } else if (
          roPressure <
            (newWaterPressure?.opMin ?? newWaterPressure?.min ?? 0) ||
          roPressure > (newWaterPressure?.opMax ?? newWaterPressure?.max ?? 0)
        ) {
          messages.push(
            `RO Water Pressure ${roPressure} ${newWaterPressure?.unit || "bar"} is outside allowed range (${newWaterPressure?.opMin ?? newWaterPressure?.min} - ${newWaterPressure?.opMax ?? newWaterPressure?.max} ${newWaterPressure?.unit || "bar"}) for Filters: ${allFilterIds}`,
          );
        }
      }

      // Air Pressure
      if (commonFields.AirPressure && commonFields.AirPressure !== "N/A") {
        const airPressure = parseFloat(commonFields.AirPressure);
        if (isNaN(airPressure)) {
          messages.push(
            `Invalid Air Pressure value for Filters: ${allFilterIds}`,
          );
        } else if (
          airPressure < (newAirPressure?.opMin ?? newAirPressure?.min ?? 0) ||
          airPressure > (newAirPressure?.opMax ?? newAirPressure?.max ?? 0)
        ) {
          messages.push(
            `Air Pressure ${airPressure} ${newAirPressure?.unit || "bar"} is outside allowed range (${newAirPressure?.opMin ?? newAirPressure?.min} - ${newAirPressure?.opMax ?? newAirPressure?.max} ${newAirPressure?.unit || "bar"}) for Filters: ${allFilterIds}`,
          );
        }
      }
    }

    if (bulkStatus === "Dry In") {
      // Air Pressure
      if (commonFields.AirPressure && commonFields.AirPressure !== "N/A") {
        const airPressure = parseFloat(commonFields.AirPressure);
        if (isNaN(airPressure)) {
          messages.push(
            `Invalid Air Pressure value for Filters: ${allFilterIds}`,
          );
        } else if (
          airPressure < (newAirPressure?.opMin ?? newAirPressure?.min ?? 0) ||
          airPressure > (newAirPressure?.opMax ?? newAirPressure?.max ?? 0)
        ) {
          messages.push(
            `Air Pressure ${airPressure} ${newAirPressure?.unit || "bar"} is outside allowed range (${newAirPressure?.opMin ?? newAirPressure?.min} - ${newAirPressure?.opMax ?? newAirPressure?.max} ${newAirPressure?.unit || "bar"}) for Filters: ${allFilterIds}`,
          );
        }
      }

      // Dryer Temperature
      if (commonFields.DryerTemp && commonFields.DryerTemp !== "N/A") {
        const tempValue = parseFloat(commonFields.DryerTemp);
        if (isNaN(tempValue)) {
          messages.push(
            `Invalid Dryer Temperature value for Filters: ${allFilterIds}`,
          );
        } else if (
          tempValue < (newTemperature?.opMin ?? newTemperature?.min ?? 0) ||
          tempValue > (newTemperature?.opMax ?? newTemperature?.max ?? 0)
        ) {
          messages.push(
            `Dryer Temperature ${tempValue} ${newTemperature?.unit || "°C"} is outside allowed range (${newTemperature?.opMin ?? newTemperature?.min} - ${newTemperature?.opMax ?? newTemperature?.max} ${newTemperature?.unit || "°C"}) for Filters: ${allFilterIds}`,
          );
        }
      }
    }

    if (messages.length > 0) {
      return {
        isValid: false,
        message: messages.join(" | "),
      };
    }

    return { isValid: true, message: "" };
  };

  const handleAuthenticate = async (resolve) => {
    if (!adhocRemarks || !adhocRemarks.trim()) {
      Swal.fire({
        icon: "error",
        title: "Remarks Required",
        text: "Please enter adhoc remarks before proceeding.",
        confirmButtonColor: "#d33",
      });
      resolve(false);
      return;
    }

    if (!reauthPassword.trim()) {
      Swal.fire({
        icon: "error",
        title: "Password Required",
        text: "Password is required!",
        confirmButtonColor: "#d33",
      });
      resolve(false);
      return;
    }
    setReauthLoading(true);
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const username = user?.UserName || "";

      const response = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
          password: reauthPassword,
        }),
      });
      const result = await response.json();
      console.log("Reauthentication response:", result);
      if (result.status) {
        setIsReauthenticated(true);
        setIsReauthModalVisible(false);
        Swal.fire({
          icon: "success",
          title: "Reauthentication Successful",
          text: "Authentication successful. Proceeding with submission.",
          confirmButtonColor: "#3085d6",
        });
        resolve({
          success: true,
          remarks: adhocRemarks.trim(),
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid Credentials",
          text: result.Message || "Invalid credentials",
          confirmButtonColor: "#d33",
        });

        resolve({ success: false });
      }
    } catch (error) {
      console.error("Reauthentication error:", error);
      Swal.fire({
        icon: "error",
        title: "Reauthentication Failed",
        text: "Failed to reauthenticate. Please try again.",
        confirmButtonColor: "#d33",
      });

      resolve({ success: false });
    } finally {
      setReauthLoading(false);
    }
  };

  const handleCancel = (resolve) => {
    setIsReauthModalVisible(false);
    resolve(false);
  };

  const promptReauthentication = async (message) => {
    console.log("Prompting reauthentication for deviation:", message);
    setIsReauthModalVisible(true);
    setReauthPassword("");
    return new Promise((resolve) => {
      window.reauthResolve = resolve;
    });
  };

  const handleBulkSubmit = async () => {
    let remarksAdhoc = "";
    let user;
    try {
      const userData = sessionStorage.getItem("user");
      if (!userData) {
        throw new Error("User data not found in session storage");
      }
      user = JSON.parse(userData);
    } catch (error) {
      console.error("Error parsing user data:", error);
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "User data is missing or invalid. Please log in again.",
        confirmButtonColor: "#d33",
      });

      return;
    }

    if (bulkFormData.length === 0 || !bulkStatus) {
      Swal.fire({
        icon: "warning",
        title: !bulkStatus ? "No Status Selected" : "No Filters",
        text: !bulkStatus
          ? "Please select a status."
          : "Please select at least one filter before submitting.",
        confirmButtonColor: "#f8bb86",
      });
      return;
    }

    const performedBy = user?.UserID || 0;
    const performedOn = new Date().toISOString().slice(0, 19).replace("T", " ");
    const filterIds = bulkFormData.map((f) => f.FilterId).join(", ");
    const description = auditLogDescription[bulkStatus] || "Bulk Update";
    const stage = processOrderMapping[bulkStatus];
    const currentStage =
      stageNameMapping[bulkFormData[0]?.Status || 0] || "Unknown";
    const newStage = stageNameMapping[stage] || "Unknown";

    const auditPayloadBase = {
      ActivityType: 1,
      PerformedBy: performedBy,
      PerformedOn: performedOn,
      Notes: `${
        isReauthenticated ? "Manual Override: " : ""
      }${description} for Filters: ${filterIds}`,
      Location: "washing",
    };

    // Check for missing fields
    const missingFieldSet = new Set();
    if (stage === 1) {
      if (!commonFields.washingReasonId) missingFieldSet.add("Washing Reason");
      if (!commonFields.RoWaterPressure)
        missingFieldSet.add("RO Water Pressure");
      if (!commonFields.AirPressure) missingFieldSet.add("Air Pressure");
    }
    if (stage === 3) {
      if (!commonFields.DryerTemp) missingFieldSet.add("Dryer Temperature");
      if (!commonFields.Duration) missingFieldSet.add("Duration");
    }

    if (missingFieldSet.size > 0) {
      Swal.fire({
        icon: "warning",
        title: "Missing Required Fields",
        html: Array.from(missingFieldSet).join(", "),
        confirmButtonColor: "#f8bb86",
      });
      return;
    }

    // Initialize deviation tracking
    let hasDeviation = false;
    const deviationMessages = [];

    // Check for invalid status transition (New/Spare to non-Wash In)
    const hasStatusZero = bulkFormData.some((item) => item.Status === 0);
    if (hasStatusZero && bulkStatus !== "Wash In") {
      const affectedFilters = bulkFormData
        .filter((item) => item.Status === 0)
        .map((f) => f.FilterId)
        .join(", ");
      const errorMessage = `Invalid Status Transition: Filters ${affectedFilters} with 'To Be Cleaned' status can only transition to 'Wash In'.`;
      hasDeviation = true;
      deviationMessages.push(errorMessage);
      console.log("Status deviation detected:", errorMessage);
    }
    // Check sequence for each filter
    for (const filter of bulkFormData) {
      const sequenceResult = await checkStageSequence(
        // filter.Barcode,
        filter.Rfid,
        processOrderMapping[bulkStatus],
        performedBy,
      );
      if (!sequenceResult.isValid) {
        hasDeviation = true;
        deviationMessages.push(sequenceResult.message);
        // await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify({
        //     ...auditPayloadBase,
        //     Notes: `Deviation: Cleaning Sequence - ${sequenceResult.message}. Filter: ${filter.FilterId}`,
        //     IsSucces: 1,
        //   }),
        // }).catch((err) =>
        //   console.error("Audit log error (Sequence Deviation):", err)
        // );
        // const notificationPayload = {
        //   Title: "Deviations",
        //   Message: `Deviation detected for Filter ${filter.FilterId}: Cleaning Sequence - ${sequenceResult.message}`,
        //   RoleID: 4,
        // };
        // console.log("Sending notification for deviation:", notificationPayload);
        // await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify(notificationPayload),
        // })
        //   .then((response) => response.json())
        //   .then((result) => {
        //     if (result.Status) {
        //       console.log(
        //         "Notification sent successfully for Filter:",
        //         filter.FilterId,
        //         notificationPayload
        //       );
        //     } else {
        //       console.warn(
        //         "Notification API failed for Filter:",
        //         filter.FilterId,
        //         result
        //       );
        //     }
        //   })
        //   .catch((err) =>
        //     console.error("Notification error (Sequence Deviation):", err)
        //   );
        console.log(
          "Sequence deviation detected for Filter:",
          filter.FilterId,
          sequenceResult.message,
        );
      }
    }

    // Check dryer duration for Dry Out
    if (bulkStatus === "Dry Out") {
      for (const filter of bulkFormData) {
        const durationResult = checkDryerDuration(filter);
        if (!durationResult.isValid) {
          hasDeviation = true;
          deviationMessages.push(durationResult.message);
          console.warn(
            JSON.stringify({
              ...auditPayloadBase,
              Notes: `(Web) Deviation: Dryer Duration - ${durationResult.message}. Filter: ${filter.FilterId}`,
              IsSucces: 1,
            }),
          );
          await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ...auditPayloadBase,
              Notes: `(Web) Deviation: Dryer Duration - ${durationResult.message}. Filter: ${filter.FilterId}`,
              IsSucces: 1,
            }),
          }).catch((err) =>
            console.error("Audit log error (Duration Deviation):", err),
          );
          const notificationPayload = {
            Title: "Deviations",
            Message: `(Web) Deviation detected for Filter ${filter.FilterId}: Dryer Duration - ${durationResult.message}`,
            RoleID: 4,
          };
          console.warn(JSON.stringify(notificationPayload));

          await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(notificationPayload),
          })
            .then((response) => response.json())
            .then((result) => {
              if (result.Status) {
                console.log(
                  "Notification sent successfully for Filter:",
                  filter.FilterId,
                  notificationPayload,
                );
              } else {
                console.warn(
                  "Notification API failed for Filter:",
                  filter.FilterId,
                  result,
                );
              }
            })
            .catch((err) =>
              console.error("Notification error (Duration Deviation):", err),
            );
          console.log(
            "Duration deviation detected for Filter:",
            filter.FilterId,
            durationResult.message,
          );
        }
      }
    }

    // Prompt reauthentication if there are deviations and not already reauthenticated
    // if (hasDeviation && !isReauthenticated) {
    //   setDeviationMessage(deviationMessages.join("; "));
    //   console.log(
    //     "Triggering reauthentication modal with message:",
    //     deviationMessages.join("; "),
    //   );
    //   const reauthResult = await promptReauthentication(
    //     deviationMessages.join("; "),
    //   );

    //   if (!reauthResult?.success) {
    //     console.log("Reauthentication failed or canceled");

    //     return;
    //   }
    //   remarksAdhoc = reauthResult.remarks;
    // }
    const pressureResult = checkPressureValues();
    if (!pressureResult.isValid) {
      hasDeviation = true;
      deviationMessages.push(pressureResult.message);
    }

    // Show deviation in drawer + ask for re-auth only if needed
    if (deviationMessages.length > 0) {
      const fullMessage = deviationMessages.join("; ");
      setDeviationMessage(fullMessage); // ← This shows red text in drawer **immediately**

      if (!isReauthenticated) {
        const reauthResult = await promptReauthentication(fullMessage);

        if (!reauthResult?.success) {
          // User cancelled or wrong password → do NOT log anything
          console.log("Reauthentication cancelled or failed");
          return;
        }

        remarksAdhoc = reauthResult.remarks;
      }
    }

    //     if (deviationMessages.length > 0) {
    //   const fullMessage = deviationMessages.join("; ");
    //   setDeviationMessage(fullMessage);   // ← This line ensures drawer shows it NOW

    //   if (!isReauthenticated) {
    //     const reauthResult = await promptReauthentication(fullMessage);

    //     if (!reauthResult?.success) {
    //       console.log("Reauthentication failed or canceled");
    //       return;
    //     }
    //     remarksAdhoc = reauthResult.remarks;
    //   }
    // }

    const cleanedPayload = bulkFormData.map((filter) => ({
      FilterId: filter.ID || 0,
      StageId: stage,
      Remarks: filter.Remarks?.trim() || "",
      Status: stage,
      washingEquipId: stage === 1 ? commonFields.washingEquipId || 0 : 0,
      AirPressure: stage === 3 ? `${commonFields.AirPressure} ` : "",
      RoWaterPressure: stage === 1 ? `${commonFields.RoWaterPressure} ` : "",
      Duration: stage === 3 ? commonFields.Duration || 0 : 0,
      DryerEquipId: stage === 3 ? commonFields.DryerEquipId || "" : "",
      DryerTemp: stage === 3 ? commonFields.DryerTemp || "" : "",
      performedBy: performedBy,
      Barcode: filter.Barcode || "",
      washingReasonId: stage === 1 ? commonFields.washingReasonId || 0 : 0,
      platform: "Web",
      Override: isReauthenticated,
      blockId: selectedBlock || 0,
    }));

    setSubmitLoading(true);
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we submit your data.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const apiUrl = `${getApiBaseUrl()}${UPDATEFILTERSTATUS}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cleanedPayload),
      });

      const responseText = await response.text();
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (err) {
        console.error("Failed to parse response JSON:", err, responseText);
        throw new Error("Invalid response format from server");
      }

      const isSuccess = result.Status || result.status;

      if (isSuccess) {
        if (hasDeviation && !isReauthenticated) {
          // Collect only the real deviation details (pressure, temperature, duration, etc.)
          let deviationDetails =
            deviationMessages.length > 0 ? deviationMessages.join("; ") : "";

          // Only add transition part if sequence check actually failed (not always)
          let transitionPart = "";
          const hasSequenceDeviation = deviationMessages.some(
            (msg) =>
              msg.includes("Attempted transition") ||
              msg.includes("Cleaning Sequence"),
          );
          if (hasSequenceDeviation) {
            transitionPart = `Transition from ${currentStage} to ${newStage} for Filters: ${filterIds}. `;
          }

          // Build final message: transition (only if relevant) + details + remarks
          const overrideMessage = `(Web) Deviation occurred: ${transitionPart}${deviationDetails}${remarksAdhoc?.trim() ? `. Remarks: ${remarksAdhoc.trim()}` : ""}`;

          await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              ...auditPayloadBase,
              Notes: overrideMessage,
              IsSucces: 1,
            }),
          }).catch((err) =>
            console.error("Audit log error (Override Deviation):", err),
          );

          const notificationPayload = {
            Title: "Deviations",
            Message: overrideMessage,
            RoleID: 4,
          };
          await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(notificationPayload),
          }).catch((err) =>
            console.error("Notification error (Override Deviation):", err),
          );

          setDeviationMessage(overrideMessage);
        }

        if (hasStatusZero && bulkStatus !== "Wash In") {
          const affectedFilters = bulkFormData
            .filter((item) => item.Status === 0)
            .map((f) => f.FilterId)
            .join(", ");
          const transitionMessage = `(Web) Deviation: Invalid Status Transition - Filters ${affectedFilters} with 'To Be Cleaned' status can only transition to 'Wash In'.`;

          await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              ...auditPayloadBase,
              Notes: transitionMessage,
              IsSucces: 1,
            }),
          }).catch((err) =>
            console.error(
              "Audit log error (Status Transition Deviation):",
              err,
            ),
          );

          const notificationPayload = {
            Title: "Deviations",
            Message: transitionMessage,
            RoleID: 4,
          };
          await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(notificationPayload),
          }).catch((err) =>
            console.error(
              "Notification error (Status Transition Deviation):",
              err,
            ),
          );
        }
        // const pressureResult = checkPressureValues();
        // if (!pressureResult.isValid) {
        //   hasDeviation = true;
        //   deviationMessages.push(pressureResult.message);
        //   const filterIds = bulkFormData
        //     .map((filter) => filter.FilterId)
        //     .join(",");
        //   // for (const filter of bulkFormData) {
        //   console.warn(
        //     JSON.stringify({
        //       ...auditPayloadBase,
        //       Notes: `(Web) Deviation: Pressure Validation - ${pressureResult.message}. Filter: ${filterIds}`,
        //       IsSucces: 1,
        //     }),
        //   );
        //   await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify({
        //       ...auditPayloadBase,
        //       Notes: `(Web) Deviation: Pressure Validation - ${pressureResult.message}. Filter: ${filterIds}`,
        //       IsSucces: 1,
        //     }),
        //   }).catch((err) =>
        //     console.error("Audit log error (Pressure Deviation):", err),
        //   );
        //   const notificationPayload = {
        //     Title: "Deviations",
        //     Message: `(Web) Deviation detected for Filter ${filterIds}: Pressure Validation - ${pressureResult.message}`,
        //     RoleID: 4,
        //   };
        //   console.warn(JSON.stringify(notificationPayload));
        //   await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify(notificationPayload),
        //   })
        //     .then((response) => response.json())
        //     .then((result) => {
        //       if (result.Status) {
        //         console.log(
        //           "Notification sent successfully for Filter:",
        //           filterIds,
        //           notificationPayload,
        //         );
        //       } else {
        //         console.warn(
        //           "Notification API failed for Filter:",
        //           filterIds,
        //           result,
        //         );
        //       }
        //     })
        //     .catch((err) =>
        //       console.error("Notification error (Pressure Deviation):", err),
        //     );
        //   // }
        //   console.log("Pressure deviation detected:", pressureResult.message);
        // }
        console.warn(
          JSON.stringify({
            ...auditPayloadBase,
            IsSucces: 1,
          }),
        );
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...auditPayloadBase,
            IsSucces: 1,
          }),
        }).catch((err) => console.error("Audit log error (Success):", err));

        Swal.fire({
          icon: "success",
          title: "Submitted!",
          text: `All filters updated successfully${
            isReauthenticated ? " (Manual Override)" : ""
          }.`,
          confirmButtonColor: "#3085d6",
        }).then(() => {
          setSelectedIds([]);
          setBulkStatus("");
          setBulkFormData([]);
          setIsManualOverride(false);
          setIsReauthenticated(false);
          onClose();
          fetchFilters(setFiltersData, setLoadingFilters);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            result.ResultMessage ||
            result.Message ||
            result.message ||
            "Something went wrong",
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          "Something went wrong while submitting the data: " + error.message,
        confirmButtonColor: "#d33",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const tableColumns = [
    {
      title: "Filter ID",
      dataIndex: "FilterId",
      key: "FilterId",
      width: "50%",
    },
    {
      title: "Remarks",
      dataIndex: "Remarks",
      key: "Remarks",
      width: "50%",
      render: (text, record, index) => (
        <TextArea
          rows={2}
          value={text}
          onChange={(e) => {
            setBulkFormData((prev) =>
              prev.map((data, i) =>
                i === index
                  ? { ...data, Remarks: e.target.value.trimStart() }
                  : data,
              ),
            );
          }}
        />
      ),
    },
  ];

  return (
    <>
      <Modal
        title="Deviation Detected"
        open={isReauthModalVisible}
        footer={[
          <Button
            key="cancel"
            onClick={() => handleCancel(window.reauthResolve)}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={reauthLoading}
            onClick={() => handleAuthenticate(window.reauthResolve)}
          >
            Authenticate
          </Button>,
        ]}
        closable={false}
      >
        <p>Deviation: {deviationMessage} Please reauthenticate to proceed.</p>
        <Input.TextArea
          placeholder="Enter remarks"
          rows={3}
          value={adhocRemarks}
          onChange={(e) => setAdhocRemarks(e.target.value)}
          style={{ marginBottom: 12 }}
        />
        <Input.Password
          placeholder="Enter your password"
          value={reauthPassword}
          onChange={(e) => {
            setReauthPassword(e.target.value);
          }}
          onPressEnter={() => handleAuthenticate(window.reauthResolve)}
        />
      </Modal>
      <style>
        {`
          .scrollable-table {
            max-height: ${Math.min(bulkFormData.length, 3) * 100}px;
            overflow-y: auto;
            margin-bottom: 1rem;
          }
        `}
      </style>
      <Drawer
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>{`Bulk Update: ${bulkStatus || "Select Status"}`}</span>
            <div>
              <Button
                type="primary"
                onClick={handleBulkSubmit}
                loading={submitLoading}
                className="btn btn-sm btn-outline-success me-2"
              >
                <i className="fa fa-check fs-4"></i>
              </Button>
            </div>
          </div>
        }
        placement="right"
        onClose={() => {
          setBulkStatus("");
          setBulkFormData([]);
          setCommonFields({
            washingEquipId: null,
            washingReasonId: null,
            RoWaterPressure: "",
            DryerTemp: "",
            Duration: null,
            AirPressure: "",
          });
          setIsManualOverride(false);
          setIsReauthenticated(false);
          setDeviationMessage("");
          onClose();
        }}
        open={visible}
        width={
          window.innerWidth <= 576
            ? "90%"
            : window.innerWidth <= 992
              ? "75%"
              : window.innerWidth <= 1440
                ? "45%"
                : "40%"
        }
        footer={null}
        size="large"
      >
        {submitLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", marginBottom: 8 }}>
            New Status
          </label>
          <Select
            style={{ width: "100%" }}
            value={bulkStatus}
            onChange={(value) => setBulkStatus(value)}
            placeholder="Select Status"
          >
            <Option value="">Select Status</Option>
            <Option value="Wash In">Wash In</Option>
            <Option value="Wash Out">Wash Out</Option>
            <Option value="Dry In">Dry In</Option>
            <Option value="Dry Out">Dry Out</Option>
            <Option value="Storage-In">Storage-In</Option>
            <Option value="Storage-Out">Storage-Out</Option>
          </Select>
        </div>
        {bulkStatus === "Wash In" || bulkStatus === "Dry In" ? (
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", marginBottom: 8 }}>
              Pressure Group
            </label>
            <Select
              loading={groupLoading}
              disabled={groupLoading || pressureGroups.length === 0}
              placeholder="Select Pressure Group"
              style={{ width: "100%" }}
              value={selectedPressureGroupId}
              onChange={setSelectedPressureGroupId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {pressureGroups.map((group) => (
                <Option key={group.Id} value={group.Id}>
                  {group.GroupName}
                </Option>
              ))}
            </Select>
            {groupDataLoading && (
              <div style={{ marginTop: 4, color: "#888", fontSize: "0.9em" }}>
                Loading group parameters...
              </div>
            )}
          </div>
        ) : null}
        <div className="scrollable-table">
          <AntTable
            columns={tableColumns}
            dataSource={bulkFormData}
            pagination={false}
            scroll={{ y: Math.min(bulkFormData.length, 3) * 100 }}
            rowKey="ID"
          />
        </div>
        {bulkStatus === "Wash In" && (
          <div className="common-fields">
            <div style={{ marginBottom: 16 }} className="d-none">
              <label style={{ display: "block", marginBottom: 8 }}>
                Washing Equipment
              </label>
              <Select
                showSearch
                placeholder="-- Select Equipment --"
                optionFilterProp="children"
                value={commonFields.washingEquipId || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    washingEquipId: value,
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {washingEquipments.map((equip) => (
                  <Option key={equip.Id} value={equip.Id}>
                    {equip.EquipmentName} ({equip.SerialNumber})
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                Washing Reason
              </label>
              <Select
                showSearch
                placeholder="-- Select Reason --"
                optionFilterProp="children"
                value={commonFields.washingReasonId || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    washingReasonId: Number(value),
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {washingReasons.map((reason) => (
                  <Option key={reason.Id} value={reason.Id}>
                    {reason.Reason}
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                RO Water Pressure
              </label>
              <Select
                showSearch
                placeholder="RO Water Pressure"
                optionFilterProp="children"
                value={commonFields.RoWaterPressure || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    RoWaterPressure: value,
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {pressureOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                Air Pressure
              </label>
              <Select
                showSearch
                placeholder="Air Pressure"
                optionFilterProp="children"
                value={commonFields.AirPressure || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    AirPressure: value,
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {airPressureSelectOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        )}
        {bulkStatus === "Dry In" && (
          <div className="common-fields">
            <div style={{ marginBottom: 16 }} className="d-none">
              <label style={{ display: "block", marginBottom: 8 }}>
                Dryer Equipment
              </label>
              <Select
                showSearch
                placeholder="Select Dryer Equipment"
                optionFilterProp="children"
                value={commonFields.DryerEquipId || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    DryerEquipId: value,
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {dryerEquipmentOptions.map((equip) => (
                  <Option key={equip.Id} value={equip.Id}>
                    {equip.EquipmentName} ({equip.SerialNumber})
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                Dryer Temperature
              </label>
              <Select
                showSearch
                placeholder=" Dryer Temperature"
                optionFilterProp="children"
                value={commonFields.DryerTemp || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    DryerTemp: value,
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {tempSelectOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                Duration
              </label>
              <Input
                type="number"
                placeholder="Enter duration"
                value={commonFields.Duration || ""}
                onChange={(e) => {
                  const num = parseInt(e.target.value, 10) || null;
                  setCommonFields((prev) => ({
                    ...prev,
                    Duration: num,
                  }));
                }}
                addonAfter="min"
                size="middle"
              />
            </div>
          </div>
        )}
        {deviationMessage && (
          <div style={{ color: "red", marginBottom: 16 }}>
            {deviationMessage}
          </div>
        )}
      </Drawer>
    </>
  );
};

BulkUpdateOffcanvas.propTypes = {
  selectedIds: PropTypes.arrayOf(
    PropTypes.shape({
      FilterId: PropTypes.string.isRequired,
      ID: PropTypes.number.isRequired,
      Status: PropTypes.number.isRequired,
      Barcode: PropTypes.string,
      LastCleaningDate: PropTypes.string,
      cleaningdays: PropTypes.number,
      Lable: PropTypes.string.isRequired,
    }),
  ).isRequired,
  setSelectedIds: PropTypes.func.isRequired,
  fetchFilters: PropTypes.func.isRequired,
  setFiltersData: PropTypes.func.isRequired,
  setLoadingFilters: PropTypes.func.isRequired,
  selectedBlock: PropTypes.number,
  isManualOverride: PropTypes.bool.isRequired,
  setIsManualOverride: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BulkUpdateOffcanvas;
